import React from 'react';
import moment from "moment";
import { now } from 'lib/utils/DateUtils';
import { ProviderNames } from 'lib/data/models/Providers';

export const timeRangeOptions = [
    { value: 'all', label: 'All' },
    { value: 'thisHour', label: 'This Hour' },
    { value: 'lastHour', label: 'Last Hour' },
    { value: 'today', label: 'Today' },
    { value: 'yesterday', label: 'Yesterday' },
    { value: 'last7days', label: 'Last 7 Days' }
]

export const eventOptions = [
    { value: 'all', label: 'All' },
    { value: 'pageview', label: 'Page View' },
    { value: 'add-to-cart', label: 'Add to Cart' },
    { value: 'checkout', label: 'Checkout' },
    { value: 'purchase', label: 'Purchase' },
    { value: 'error', label: 'Error' }
];

export const allMetricOptions = [
    { value: 'Select', label: 'Select', disabled: true },
    { value: 'ROAS', label: 'ROAS' },
    { value: 'CPP', label: 'CPP' },
    { value: 'AOV', label: 'AOV' },
    { value: 'Adspend', label: 'Adspend' },
    { value: 'Revenue', label: 'Revenue' },
    { value: 'Profit', label: 'Profit' },
    { value: 'Conv Rate', label: 'Conv Rate' },
    { value: 'Orders', label: 'Orders' },
]

export const goalMetricOptions = [
    { value: 'Select', label: 'Select', disabled: true },
    { value: 'ROAS', label: 'ROAS' },
    { value: 'CPP', label: 'CPP' },
    { value: 'AOV', label: 'AOV' },
]

export const allPerformanceOptions = [
    { value: 'Select', label: 'Select', disabled: true },
    { value: 'Below Goal', label: 'Below Goal' },
    { value: 'Above Goal', label: 'Above Goal' },
    { value: 'Lowest', label: 'Lowest' },
    { value: 'Highest', label: 'Highest' }
]

export const highLowPerformanceOptions = [
    { value: 'Select', label: 'Select', disabled: true },
    { value: 'Lowest', label: 'Lowest' },
    { value: 'Highest', label: 'Highest' }
]

export const dataColumns = [
    {
        title: 'Event',
        dataIndex: 'event',
        key: 'event',
        showFilter: true
    },
    {
        title: 'Date',
        dataIndex: 'date',
        key: 'Date',
        render: (text, record, index) => {
            // text is UTC
            var then = moment(text);
            return <div className="date-value">
                <span>{then.format('M/D/YY h:mm:ss a')}</span><br />
                <small>({moment.duration(now().diff(then)).humanize()} ago)</small>
            </div>
        }
    },
    {
        title: 'Host',
        dataIndex: 'host',
        key: 'host',
        showFilter: true
    },
    {
        title: 'Location',
        dataIndex: 'location',
        key: 'location',
        showFilter: true
    },
    {
        title: 'UTM Source',
        dataIndex: 'utm_source',
        key: 'utm_source',
        showFilter: true,
        filterType: 'text'
    },
    {
        title: 'UTM Medium',
        dataIndex: 'utm_medium',
        key: 'utm_medium',
        showFilter: true,
        filterType: 'text'
    },
    {
        title: 'UTM Campaign',
        dataIndex: 'utm_campaign',
        key: 'utm_campaign',
        showFilter: true,
        filterType: 'text'
    },
    {
        title: 'UTM Term',
        dataIndex: 'utm_term',
        key: 'utm_term',
        showFilter: true,
        filterType: 'text'
    },
    {
        title: 'UTM Content',
        dataIndex: 'utm_content',
        key: 'utm_content',
        showFilter: true,
        filterType: 'text'
    },
    {
        title: 'Data',
        dataIndex: 'data',
        key: 'data',
        render: (text, record, index) => {
            if (text) {
                text = JSON.parse(text);
                let date = moment(text.orderDate);
                text.orderDate = date.format('M/D/YY h:mm:ss a')
                text = JSON.stringify(text);
            }
            return <div className="long-text-wrapper">
                {text}
            </div>
        }
    },
    {
        title: 'Price',
        dataIndex: 'price',
        key: 'price',
        showFilter: true,
        filterType: 'text',
        render: (text, record, index) => {
            try {
                if (text) {
                    text = '$' + parseFloat(text).toFixed(2);
                }
            } catch (e) { }
            return <div>{text}</div>
        }
    },
    {
        title: 'IP',
        dataIndex: 'ip',
        key: 'ip',
        showFilter: true,
        filterType: 'text'
    },
    {
        title: 'User Agent',
        dataIndex: 'user_agent',
        key: 'user_agent'
    },
    {
        title: 'Client Fingerprint',
        dataIndex: 'client_fingerprint',
        key: 'client_fingerprint',
        showFilter: true,
        filterType: 'text'
    },
    {
        title: 'Server Fingerprint',
        dataIndex: 'server_fingerprint',
        key: 'server_fingerprint',
        showFilter: true,
        filterType: 'text'
    },
    {
        title: 'Session',
        dataIndex: 'session',
        key: 'session',
        showFilter: true,
        filterType: 'number',
        render: (text, record, index) => {
            return <div className="long-text-wrapper">
                {text}
            </div>
        }
    },
    {
        title: 'Parent Session',
        dataIndex: 'parent_session',
        key: 'parent_session',
        showFilter: true,
        filterType: 'text',
        render: (text, record, index) => {
            return <div className="long-text-wrapper">
                {text}
            </div>
        }
    }

];

// Gives known/active campaigns precedence.
const unknownCompare = (a, b) => {
    if (!a.provider) {
        if (!b.provider) {
            console.log(`Unknown`, a, b, uc)
            return 0;
        } else {
            return 1;
        }
    } else if (!b.provider) {
        if (!a.provider) {
            console.log(`Unknown`, a, b, uc)
            return 0;
        } else {
            return -1;
        }
    }
}

const providerCompare = (a, b) => {
    // if different providers, and both are 0, put the Adaya provider after others (if it's there)
    if (!a.provider != b.provider && (!a.totals.roas && !b.totals.roas)) {
        if (a.provider == ProviderNames.ADAYA) return 1;
        if (b.provider == ProviderNames.ADAYA) return -1;
        return a.provider.localeCompare(b.provider); // todo: figure out some provider sorting rules
    }
    return 0;
}

export const sortFunctions = {
    // Best Performing Sorts
    'Highest Adspend': (a, b) => {
        let uc = unknownCompare(a, b);
        if (uc == 1 || uc == -1) return uc;
        let pc = providerCompare(a, b);
        if (pc == 1 || pc == -1) return pc;
        if (a.totals.adspend < b.totals.adspend) return 1;
        if (a.totals.adspend > b.totals.adspend) return -1;
        return 0;
    },
    'Highest ROAS': (a, b) => {
        let uc = unknownCompare(a, b);
        if (uc == 1 || uc == -1) return uc;
        let pc = providerCompare(a, b);
        if (pc == 1 || pc == -1) return pc;
        if (a.totals.roas < b.totals.roas) return 1;
        if (a.totals.roas > b.totals.roas) return -1;
        return 0;
    },
    'Highest CPP': (a, b) => {
        let uc = unknownCompare(a, b);
        if (uc == 1 || uc == -1) return uc;
        let pc = providerCompare(a, b);
        if (pc == 1 || pc == -1) return pc;
        if (a.totals.cpp < b.totals.cpp) return 1;
        if (a.totals.cpp > b.totals.cpp) return -1;
        return 0;
    },
    'Highest Revenue': (a, b) => {
        let uc = unknownCompare(a, b);
        if (uc == 1 || uc == -1) return uc;
        let pc = providerCompare(a, b);
        if (pc == 1 || pc == -1) return pc;
        if (a.totals.revenue < b.totals.revenue) return 1;
        if (a.totals.revenue > b.totals.revenue) return -1;
        return 0;
    },
    'Highest Profit': (a, b) => {
        let uc = unknownCompare(a, b);
        if (uc == 1 || uc == -1) return uc;
        let pc = providerCompare(a, b);
        if (pc == 1 || pc == -1) return pc;
        if (a.totals.profit < b.totals.profit) return 1;
        if (a.totals.profit > b.totals.profit) return -1;
        return 0;
    },
    'Highest Conv Rate': (a, b) => {
        let uc = unknownCompare(a, b);
        if (uc == 1 || uc == -1) return uc;
        let pc = providerCompare(a, b);
        if (pc == 1 || pc == -1) return pc;
        if (a.totals.scores.conversionRate < b.totals.scores.conversionRate) return 1;
        if (a.totals.scores.conversionRate > b.totals.scores.conversionRate) return -1;
        return 0;
    },
    'Highest Orders': (a, b) => {
        let uc = unknownCompare(a, b);
        if (uc == 1 || uc == -1) return uc;
        let pc = providerCompare(a, b);
        if (pc == 1 || pc == -1) return pc;
        if (a.totals.orders < b.totals.orders) return 1;
        if (a.totals.orders > b.totals.orders) return -1;
        return 0;
    },
    'Highest AOV': (a, b) => {
        let uc = unknownCompare(a, b);
        if (uc == 1 || uc == -1) return uc;
        let pc = providerCompare(a, b);
        if (pc == 1 || pc == -1) return pc;
        if (a.totals.aov < b.totals.aov) return 1;
        if (a.totals.aov > b.totals.aov) return -1;
        return 0;
    },

    // Worst Perform Sorts:
    'Lowest Adspend': (a, b) => {
        let uc = unknownCompare(a, b);
        if (uc == 1 || uc == -1) return uc;
        let pc = providerCompare(a, b);
        if (pc == 1 || pc == -1) return pc;
        if (a.totals.adspend < b.totals.adspend) return -1;
        if (a.totals.adspend > b.totals.adspend) return 1;
        return 0;
    },
    'Lowest ROAS': (a, b) => {
        let uc = unknownCompare(a, b);
        if (uc == 1 || uc == -1) return uc;
        let pc = providerCompare(a, b);
        if (pc == 1 || pc == -1) return pc;
        if (a.totals.roas < b.totals.roas) return -1;
        if (a.totals.roas > b.totals.roas) return 1;
        return 0;
    },
    'Lowest CPP': (a, b) => {
        let uc = unknownCompare(a, b);
        if (uc == 1 || uc == -1) return uc;
        let pc = providerCompare(a, b);
        if (pc == 1 || pc == -1) return pc;
        if (a.totals.cpp < b.totals.cpp) return -1;
        if (a.totals.cpp > b.totals.cpp) return 1;
        return 0;
    },
    'Lowest Revenue': (a, b) => {
        let uc = unknownCompare(a, b);
        if (uc == 1 || uc == -1) return uc;
        let pc = providerCompare(a, b);
        if (pc == 1 || pc == -1) return pc;
        if (a.totals.revenue < b.totals.revenue) return -1;
        if (a.totals.revenue > b.totals.revenue) return 1;
        return 0;
    },
    'Lowest Profit': (a, b) => {
        let uc = unknownCompare(a, b);
        if (uc == 1 || uc == -1) return uc;
        let pc = providerCompare(a, b);
        if (pc == 1 || pc == -1) return pc;
        if (a.totals.profit < b.totals.profit) return -1;
        if (a.totals.profit > b.totals.profit) return 1;
        return 0;
    },
    'Lowest Conv Rate': (a, b) => {
        let uc = unknownCompare(a, b);
        if (uc == 1 || uc == -1) return uc;
        let pc = providerCompare(a, b);
        if (pc == 1 || pc == -1) return pc;
        if (a.totals.scores.conversionRate < b.totals.scores.conversionRate) return -1;
        if (a.totals.scores.conversionRate > b.totals.scores.conversionRate) return 1;
        return 0;
    },
    'Lowest Orders': (a, b) => {
        let uc = unknownCompare(a, b);
        if (uc == 1 || uc == -1) return uc;
        let pc = providerCompare(a, b);
        if (pc == 1 || pc == -1) return pc;
        if (a.totals.orders < b.totals.orders) return -1;
        if (a.totals.orders > b.totals.orders) return 1;
        return 0;
    },
    'Lowest AOV': (a, b) => {
        let uc = unknownCompare(a, b);
        if (uc == 1 || uc == -1) return uc;
        let pc = providerCompare(a, b);
        if (pc == 1 || pc == -1) return pc;
        if (a.totals.aov < b.totals.aov) return -1;
        if (a.totals.aov > b.totals.aov) return 1;
        return 0;
    }

}
